import React from 'react';
import { Layout, Button, Menu, Typography, Row, Col, Card, Collapse } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './LandingPage.less';

const { Header, Content, Footer } = Layout;
const { Panel } = Collapse;

const features = [
  { key: 'feature1', img: 'https://placehold.co/480x300' },
  { key: 'feature2', img: 'https://placehold.co/480x300' },
  { key: 'feature3', img: 'https://placehold.co/480x300' },
];

const plans = [
  { 
    tier: 'free', 
    price: '$0', 
    benefits: [
      'landing.price.free.b1',
      'landing.price.free.b2',
      'landing.price.free.b3'
    ]
  },
  { 
    tier: 'pro', 
    price: '$9.9', 
    benefits: [
      'landing.price.pro.b1',
      'landing.price.pro.b2',
      'landing.price.pro.b3'
    ]
  },
  { 
    tier: 'enterprise', 
    price: 'Custom', 
    benefits: [
      'landing.price.enterprise.b1',
      'landing.price.enterprise.b2',
      'landing.price.enterprise.b3'
    ]
  },
];

function LandingPage() {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  return (
    <Layout className="landing-layout">
      <Header className="landing-header">
          <div className="container header-inner">
            <div className="logo">LOGO</div>

            <Menu mode="horizontal" theme="dark" selectable={false} className="landing-menu">
              <Menu.Item key="features" onClick={() => document.getElementById('features').scrollIntoView({ behavior: 'smooth' })}>{t('landing.nav.features')}</Menu.Item>
              <Menu.Item key="pricing" onClick={() => document.getElementById('pricing').scrollIntoView({ behavior: 'smooth' })}>{t('landing.nav.pricing')}</Menu.Item>
              <Menu.Item key="faq" onClick={() => document.getElementById('faq').scrollIntoView({ behavior: 'smooth' })}>{t('landing.nav.faq')}</Menu.Item>
            </Menu>

            <div className="right-actions">
              <select value={i18n.language} onChange={e => i18n.changeLanguage(e.target.value)} className="lang-select">
                <option value="en">EN</option>
                <option value="zh-CN">简体</option>
                <option value="zh-TW">繁體</option>
                <option value="ja">日本語</option>
              </select>
              <Button type="primary" size="large" style={{ marginLeft: 12 }} onClick={() => navigate('/login')}>{t('landing.start')}</Button>
            </div>
        </div>
      </Header>

      <Content>
        {/* Hero */}
        <section className="hero">
          <div className="container hero-inner">
            <div className="hero-text">
              <Typography.Title level={1}>{t('landing.hero.title')}</Typography.Title>
              <Typography.Paragraph className="subtitle">{t('landing.hero.subtitle')}</Typography.Paragraph>
              <Button type="primary" size="large" onClick={() => navigate('/login')}>{t('landing.start')}</Button>
            </div>
            <img src="https://placehold.co/600x380" alt="hero" className="hero-img" />
          </div>
        </section>

        {/* Features */}
        <section id="features" className="features">
          <div className="container">
            <Row gutter={[32, 32]} justify="center">
              {features.map(f => (
                <Col xs={24} md={8} key={f.key}>
                  <div className="feature-card">
                    <img src={f.img} alt="feature" className="feature-img" />
                    <Typography.Title level={4}>{t(`landing.${f.key}.title`)}</Typography.Title>
                    <Typography.Paragraph>{t(`landing.${f.key}.desc`)}</Typography.Paragraph>
                  </div>
                </Col>
              ))}
            </Row>
          </div>
        </section>

        {/* Pricing */}
        <section id="pricing" className="pricing">
          <div className="container">
            <Typography.Title level={2} style={{ textAlign: 'center' }}>{t('landing.pricingTitle')}</Typography.Title>
            <Row gutter={[24, 24]} justify="center">
              {plans.map(p => (
                <Col xs={24} md={8} key={p.tier}>
                  <Card bordered={false} title={t(`landing.price.${p.tier}`)} className="price-card">
                    <Typography.Title level={3}>{p.price}</Typography.Title>
                    <ul style={{textAlign:'left', padding:'0 16px', listStyle:'disc'}}>
                      {p.benefits.map(b => (
                        <li key={b} style={{marginBottom:8}}>{t(b)}</li>
                      ))}
                    </ul>
                    <Button type="primary" block onClick={() => navigate('/login')}>{t('landing.start')}</Button>
                  </Card>
                </Col>
              ))}
            </Row>
          </div>
        </section>

        {/* FAQ */}
        <section id="faq" className="faq">
          <div className="container">
            <Typography.Title level={2} style={{ textAlign: 'center' }}>{t('landing.faqTitle')}</Typography.Title>
            <Collapse accordion bordered={false} className="faq-list">
              {[1, 2, 3, 4, 5].map(n => (
                <Panel header={t(`landing.faq.q${n}`)} key={n}>
                  <Typography.Paragraph>{t(`landing.faq.a${n}`)}</Typography.Paragraph>
                </Panel>
              ))}
            </Collapse>
          </div>
        </section>
      </Content>

      <Footer className="landing-footer">©2025 Koepo</Footer>
    </Layout>
  );
}

export default LandingPage;